import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import Shell from "../components/Shell";
import api, { formatApiError } from "../lib/api";

export default function ResetPassword() {
    const [params] = useSearchParams();
    const navigate = useNavigate();
    const token = params.get("token") || "";
    const [password, setPassword] = useState("");
    const [confirm, setConfirm] = useState("");
    const [done, setDone] = useState(false);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const onSubmit = async (e) => {
        e.preventDefault();
        setError("");
        if (password.length < 8) return setError("Password must be at least 8 characters");
        if (password !== confirm) return setError("Passwords do not match");
        setLoading(true);
        try {
            await api.post("/auth/reset-password", { token, password });
            setDone(true);
            setTimeout(() => navigate("/login"), 2000);
        } catch (err) { setError(formatApiError(err)); }
        setLoading(false);
    };

    return (
        <Shell variant="public">
            <div className="max-w-md mx-auto px-6 py-20 animate-fade-in">
                <h1 className="font-heading text-3xl font-light mb-3">Set a new password</h1>
                {done ? (
                    <div data-testid="reset-done" className="text-sm text-emerald-800 bg-emerald-50 border border-emerald-200 px-4 py-3 rounded-sm">Password updated. Redirecting…</div>
                ) : (
                    <form onSubmit={onSubmit} className="space-y-5" data-testid="reset-form">
                        <div>
                            <label className="input-label">New password</label>
                            <input data-testid="reset-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="input-base" />
                        </div>
                        <div>
                            <label className="input-label">Confirm password</label>
                            <input data-testid="reset-confirm" type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)} className="input-base" />
                        </div>
                        {error && <div className="text-sm text-red-700">{error}</div>}
                        <button data-testid="reset-submit" disabled={loading} className="btn-primary w-full">{loading ? "Saving…" : "Update password"}</button>
                    </form>
                )}
                <div className="mt-8 text-sm"><Link to="/login" className="text-zinc-500 hover:text-black">← Back to sign in</Link></div>
            </div>
        </Shell>
    );
}
